import React from 'react'
import { useSelector } from 'react-redux'

import { LoginModal } from './LoginModal'
import { SignUpModal } from './SignUpModal'
import { ForgotModal } from './ForgotModal'
import { NewPasswordRequiredModal } from './NewPasswordRequiredModal'
import { ModalType } from '../../states/modals/ModalType.constants'
import { ChangePasswordModal } from './ChangePasswordModal'
import { ThankyouSignUpModal } from './ThankyouSignUpModal'
import { ConfirmEmailModal } from './ConfirmEmailModal'
import MessageModal from './MessageModal'

interface IAuthModalManagerProps {}

export const AuthModalManager: React.FC<IAuthModalManagerProps> = () => {
  const { modalType, data }: { modalType: string; data: any } = useSelector(
    ({ modals }) => modals
  )

  const DisplayModal = {
    [ModalType.LOGIN]: LoginModal,
    [ModalType.SIGN_UP]: SignUpModal,
    [ModalType.FORGOT]: ForgotModal,
    [ModalType.NEW_PASSWORD_REQUIRED]: NewPasswordRequiredModal,
    [ModalType.CHANGE_PASSWORD]: ChangePasswordModal,
    [ModalType.CONFIRM_EMAIL]: ConfirmEmailModal,
    [ModalType.THANK_YOU_SIGNUP]: ThankyouSignUpModal,
    [ModalType.MESSAGE]: MessageModal,
  }[modalType]
  let props = {}
  if (!modalType || !DisplayModal) {
    return null
  }
  if (data) {
    props = data.props
  }
  return <DisplayModal {...props} />
}

export default AuthModalManager
